<ng-container style="text-align: center;" *ngIf="data.allMissingColumns?.includes(field) || fieldInMissingData(field); else elseBlock">
    <span [pTooltip]="getTooltipContent()" style="text-align: center;">
      <i class="pi pi-times-circle" style="color: red; font-size: 1.5rem; cursor: pointer;"></i>
    </span>
</ng-container>
<ng-template #elseBlock></ng-template>
